// TUT-568 — a busca da LISTA do Agendamento (`/agendamento-lista`). Mora num
// arquivo próprio, e não junto da do quadro: o censo das listas
// (`list-route-contract.test.ts`) lê o arquivo do helper inteiro, e o do quadro
// não é lista.
//
// Sem página: a lista é o quadro em tabela (até 100 por pendência, a mesma
// fonte e o mesmo teto do Kanban), montada no cliente, sem consulta própria a
// paginar nem a ordenar no servidor — o Kanban também não pagina.
import { TIPOS_DE_ITEM, type TipoDeItem } from "@brevi/ui-kit/cor-do-tipo";

import { periodoDaBusca } from "../lib/periodo-de-datas";
import { recorteDaEntregaDaBusca } from "../lib/recorte-da-entrega";
import { texto, type AgendamentoListaSearch, type PrazosSearch } from "./buscas";

/**
 * Lista fechada conferida aqui: o status, o tipo e a faixa inventados caem (a
 * lista abre no padrão, e não num vazio sem motivo); `...resto` preserva o que
 * não é desta tela.
 */
export function validarBuscaDaListaDoAgendamento(busca: Record<string, unknown>): AgendamentoListaSearch {
  const { q, status, cliente, tipo, entrega, entregaDe, entregaAte, periodoDe, periodoAte, noPrazo, ...resto } = busca;
  return {
    ...resto,
    q: texto(q),
    status: status === "recusada" || status === "todos" || status === "entregues" ? status : undefined,
    cliente: texto(cliente),
    tipo: (TIPOS_DE_ITEM as readonly unknown[]).includes(tipo) ? (tipo as TipoDeItem) : undefined,
    // TUT-578 — a faixa (ou `todas`) e o período do prazo de entrega.
    ...recorteDaEntregaDaBusca({ entrega, entregaDe, entregaAte }),
    // TUT-578 — o período e o "no prazo" das Entregues (a Medição).
    periodoDe: undefined,
    periodoAte: undefined,
    ...periodoDaBusca({ periodoDe, periodoAte }),
    noPrazo: noPrazo === "sim" ? "sim" : undefined,
  } as AgendamentoListaSearch;
}

/**
 * O link salvo da tela de Prazos (que saiu na TUT-568) abre a lista do
 * Agendamento no recorte equivalente: os vencidos e as faixas de 24 h e 72 h
 * viram a faixa da entrega; o resto abre a lista inteira.
 */
export function entregaDoLinkDePrazos(busca: Pick<PrazosSearch, "status" | "vence">): AgendamentoListaSearch {
  if (busca.status === "overdue") return { entrega: "vencidos" };
  if (busca.vence === "24h") return { entrega: "ate-24h" };
  if (busca.vence === "72h") return { entrega: "24-72h" };
  return {};
}
